import { Location } from "vue-router";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import { PaymentPackage, PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { SystemSettings } from "@scrile/api-provider/dist/api/SystemSettingsProvider";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import { OnboardingData } from "@/hooks/useOnboarding/types";
import { StorageItems } from "@/types";
import { GlobalAudioPlayerFileState } from "@/components/GlobalAudioPlayer/types";

export interface StateRoot {
  user: User | null;
  verified: UserVerificationStatus;
  socialLogin: boolean;
  authorities: string[];
  redirectPath: Location | null;
  doNotDisturb: boolean;
  userBalance: number;
  systemSettings: SystemSettings | null;
  creditCardAllowed: boolean;
  publicPaymentSystems: PaymentSystemPublic[];
  creditCards: CreditCardAssignment[];
  darkMode: boolean;
  nSFWUserSettings: boolean | null;
  mySubscriptionLevels: SubscriptionLevel[] | null;
  paymentPackages: StorageItems<PaymentPackageEnum, PaymentPackage>;
  tags: StorageItems<TagInfoType, TagInfo>;
  globalPlayer: GlobalAudioPlayerFileState | null;
  onboarding: OnboardingData | null;
}
export const state = (): StateRoot => ({
  user: null,
  verified: UserVerificationStatus.UNVERIFIED,
  socialLogin: false,
  authorities: [],
  redirectPath: null,
  doNotDisturb: false,
  userBalance: 0,
  systemSettings: null,
  creditCardAllowed: true,
  publicPaymentSystems: [],
  creditCards: [],
  darkMode: false,
  nSFWUserSettings: null,
  mySubscriptionLevels: null,
  paymentPackages: {},
  tags: {},
  globalPlayer: null,
  onboarding: null,
});
